import script from "./InstallAppModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstallAppModal.vue?vue&type=script&setup=true&lang=ts"

import "./InstallAppModal.vue?vue&type=style&index=0&id=fa13c472&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa13c472"]])

export default __exports__